import React, { useState } from 'react';
import { Popover, OptionList, Icon } from '@shopify/polaris';
import { SelectMinor } from '@shopify/polaris-icons';

// A dropdown for picking a limit's variant. Looks like a Polaris Select when
// closed, but opens a Polaris list instead of the browser's native one: the native
// list can't be styled, and on Windows its options sit hard against the left edge.
function VariantSelect({ options, value, onChange, label = 'Variant' }) {
  const [open, setOpen] = useState(false);
  const selected = options.find((option) => option.value === value) || options[0];

  const activator = (
    <button
      type="button"
      className="og-select"
      aria-label={label}
      aria-haspopup="listbox"
      aria-expanded={open}
      onClick={() => setOpen((isOpen) => !isOpen)}
    >
      <span className="og-select__value">{selected ? selected.label : ''}</span>
      <span className="og-select__icon" aria-hidden="true">
        <Icon source={SelectMinor} />
      </span>
    </button>
  );

  return (
    <Popover
      active={open}
      activator={activator}
      onClose={() => setOpen(false)}
      preferredAlignment="left"
      fullWidth
      autofocusTarget="first-node"
    >
      <OptionList
        options={options}
        selected={[value]}
        onChange={(picked) => {
          setOpen(false);
          if (picked[0] !== value) onChange(picked[0]);
        }}
      />
    </Popover>
  );
}

export default VariantSelect;
